interface PaymentChevronDownProps {
  width?: string | number;
  height?: string | number;
  color?: string;
  className?: string;
}

const PaymentChevronDown = ({
  width = "12",
  height = "12",
  color = "#374151",
  className = "",
}: PaymentChevronDownProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_payment_chevron_down)">
      <path
        d="M6.47417 9.51411C6.21304 9.77524 5.79078 9.77524 5.53242 9.51411L0.19585 4.18032C-0.0652833 3.91918 -0.0652834 3.49692 0.19585 3.23857C0.456984 2.98021 0.879242 2.97743 1.1376 3.23857L5.99913 8.1001L10.8634 3.23579C11.1246 2.97465 11.5468 2.97465 11.8052 3.23579C12.0635 3.49692 12.0663 3.91918 11.8052 4.17754L6.47417 9.51411Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_payment_chevron_down">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PaymentChevronDown;
